module.exports = __webpack_public_path__ + "static/p04_back-5d679feb78151721c1c3804c9b93946a.jpg";